<template>
  <button
    type="button"
    :class="[
      'btn',
      'add-to-wishlist',
      'add-to-wishlist--heart',
      {'add-to-wishlist--filled' : isInWishlist },
    ]"
    :data-action-add="addToWishlistUrl"
    :data-action-remove="removeFromWishlistUrl"
    :data-pid="isUniqueSize ? uniqueSizeVariantPid : variationGroupIdData"
    :data-default-error-msg="$msg('wishlist.default.error','wishlist')"
    @click="buttonHandler"
  >
    <span class="default-content visually-hidden">
      {{ $msg('button.add_to_wishlist.txt', 'wishlist', null) }}
    </span>
  </button>
</template>

<script>
import getFrontConfig from '../../common/getFrontConfig';
import { urlWithSearchParams } from '../../common/utils/url';
import { getVariationGroupId } from '../../common/helpers/productIdHelpers';
import { productSizesMixin } from '../mixins/productPropSizesMixin';

const FRONT_CONFIG = getFrontConfig();

export default {
  name: 'BaseWishlistHeart',

  mixins: [
    productSizesMixin,
  ],

  props: {
    productId: {
      type: String,
      required: true,
    },
    isPdpContext: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      addToWishlistUrl: FRONT_CONFIG.urls.addToWishlist,
      removeFromWishlistUrl: urlWithSearchParams(
        FRONT_CONFIG.urls.removeFromWishlist,
        { isPdpContext: this.isPdpContext },
      ),
      isInWishlist: this.product.isInWishlist,
      variationGroupIdData: this.productId,
      isUniqueSize: false,
      uniqueSizeVariantPid: null,
    };
  },

  watch: {
    productId(previousProductId, newProductId) {
      if (getVariationGroupId(previousProductId) !== getVariationGroupId(newProductId)) {
        this.handleHeartStatus(this.productId);
        this.variationGroupIdData = getVariationGroupId(this.productId);
        this.uniqueSizeVariantPid = this.getUniqueSizeVariantPid();
      }
    },
  },

  beforeDestroy() {
    this.$eventBus?.$off('wishlist-heart:updated', this.updateWishlist);
    this.$eventBus?.$off('wishlist-heart:update-from-cart', this.handleHeartStatus);
  },
  mounted() {
    // When a product is removed from PDP, all variations are removed.
    // When a product is removed from Cart, only selected is removed, and other variants must remain in wishlist.
    this.$eventBus?.$on('wishlist-heart:updated', this.updateWishlist);
    this.$eventBus?.$on('wishlist-heart:update-from-cart', this.handleHeartStatus);
    this.isUniqueSize = this.hasUniqueSize();
    this.uniqueSizeVariantPid = this.getUniqueSizeVariantPid();

    this.handleHeartStatus(this.productId);
  },
  methods: {
    buttonHandler(event) {
      this.$eventBus?.$emit(
        'wishlist-heart:clicked',
        event.currentTarget,
        this.product,
      );
    },
    updateWishlist(result) {
      this.isInWishlist = result;
    },
    updateVGid(newId) {
      this.variationGroupIdData = newId;
    },
    async handleHeartStatus(productId, vGroupProductId) {
      const isCurrentProduct = vGroupProductId
        ? getVariationGroupId(this.productId) === vGroupProductId : true;
      if (!isCurrentProduct) {
        return;
      }

      const result = await this.checkProductVariations(vGroupProductId || productId);

      this.updateWishlist(result);
    },
    checkProductVariations(productId) {
      const url = FRONT_CONFIG.urls.checkProductsInWishlist;

      return fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          pid: productId,
        }),
      })
        .then((response) => response.json())
        .then((response) => response.result);
    },
  },
};
</script>
